import { createSlice } from "@reduxjs/toolkit";

const initialTransactionsReportState = {
  listLoading: false,
  actionsLoading: false,
  chartLoading: false,
  totalCount: 0,
  entities: null,
  lastError: null,
  chartEntities: null,
  xlsFilename: null
};
export const callTypes = {
  list: "list",
  action: "action",
  chart: "chart"
};

export const transactionsReportSlice = createSlice({
  name: "transactionsReport",
  initialState: initialTransactionsReportState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      }
      if (action.payload.callType === callTypes.chart) {
        state.chartLoading = false;
      }
      if (action.payload.callType === callTypes.action) {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      }
      if (action.payload.callType === callTypes.chart) {
        state.chartLoading = true;
      }
      if (action.payload.callType === callTypes.action) {
        state.actionsLoading = true;
      }
    },

    // findtransactionsReport
    transactionsReportListFetched: (state, action) => {
      const { totalCount, entities, error } = action.payload;
      state.listLoading = false;
      state.error = error || null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    transactionsReportListExport: (state, action) => {
      const { xlsFilename } = action.payload;
      state.actionsLoading = false;
      state.xlsFilename = xlsFilename;
    },
    transactionsChartDetailsFetched: (state, action) => {
      const { chartEntities } = action.payload;
      state.chartLoading = false;
      state.chartEntities = chartEntities;
    }
  }
});
